import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-info-circle',
  templateUrl: './icon-info-circle.component.html',
  styles: []
})
export class IconInfoCircleComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
